import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['list', 'template'];

  connect() {
    this.nextIndex = this.listTarget.children.length;
  }

  add(event: Event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.nextIndex.toString());
    this.listTarget.insertAdjacentHTML('beforeend', content);
    this.nextIndex += 1;
  }

  declare listTarget: HTMLElement;
  declare templateTarget: HTMLTemplateElement;
  declare nextIndex: number;
}
